import * as React from "react";
function XxlIcon() {
    return React.createElement("path", { d: "M24 43.3077L12.6924 32L14.3539 30.3385L24 39.9462L33.6462 30.3385L35.3077 32L24 43.3077ZM14.3539 17.6615L12.6924 16L24 4.69238L35.3077 16L33.6462 17.6615L24 8.05383L14.3539 17.6615Z", fill: "currentColor" });
}
export default XxlIcon;
//# sourceMappingURL=Xxl.js.map